import classnames from 'classnames';

import { CONNECTION_PLUGINS_STEP_ONE } from 'constants/plugins';

import customer from 'assets/bosta-images/coustomerChats.gif';
import merchant from 'assets/bosta-images/merchantChat.gif';

import './ConnectionFirstStep.less';

const ConnectionFirstStep = ({ intl, businessInfo, platform }) => {
  const { formatMessage } = intl;

  return (
    <div className="br-connection-first-step__body-container">
      <div className="br-connection-first-step__images-section">
        <div className="br-connection-first-step__merchant">
          <img
            alt="merchant"
            src={merchant}
            className="br-connection-first-step__merchant-img"
          />
          <div className="br-connection-first-step__merchant-title text-gray subheading">
            {formatMessage({
              id: `chats_plugins.install_plugins.merchant`
            })}
          </div>
        </div>
        <div className="br-connection-first-step__customer">
          <img
            src={customer}
            className="br-connection-first-step__customer-img"
            alt="customer"
          />
          <div className="br-connection-first-step__customer-title text-gray subheading">
            {formatMessage({
              id: `chats_plugins.install_plugins.customer`
            })}
          </div>
        </div>
      </div>
      <div className="br-connection-first-step__description body-medium">
        <span>
          {formatMessage(
            {
              id: `chats_plugins.install_plugins.create_order_manually`
            },
            {
              span: (children) => <span>{children}</span>
            }
          )}
        </span>
      </div>
      <div className="br-connection-first-step__steps">
        <div className="br-connection-first-step__steps__title text-gray subheading">
          {formatMessage({
            id: `chats_plugins.install_plugins.how_it_work`
          })}
        </div>
        <div className="br-connection-first-step__connection-steps">
          {CONNECTION_PLUGINS_STEP_ONE[platform?.keyName?.toUpperCase()].map(
            ({ id, title }) => (
              <div
                key={id}
                className="br-connection-first-step__connection-steps--content"
              >
                <span
                  className={classnames(
                    'br-connection-first-step__connection-steps--id text-gray'
                  )}
                >
                  {id}.
                </span>
                <span className="br-connection-first-step__connection-steps--title">
                  {title}
                </span>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectionFirstStep;
